import React from 'react';
import { connect } from 'react-redux';
import { toEuros, estEnCoursDeChargement } from '../../App_Code/Utils';
import ConseilSyndical from '../../App_Data/ConseilSyndical';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Tableau from '../Tableau';

function ClasseSolde(solde) {
    return solde >= 0.0 ? 'text-right strong text-success' : 'text-right strong text-danger';
}

const LotsList=(props) => {
    const LsLots = props.LsLots;
    const nbLots = LsLots.length -1;
    const listItems = LsLots.map((Lot,i) =>
        <span key={i}>
            Lot {Lot.Lot} : {Lot.Libelle}<br/>
        </span>            
        );
    return (
        <p>{listItems}</p>
    );
}

const LigneCoproprio = ({ Ind, Cpt, Couleur, LsLots }) => {
    const CS = ConseilSyndical(Ind.CS);
    let pays =Ind.Adresse.Pays;
    if (pays==="FRANCE") {pays=""};

    return (
        <tr className={Couleur}>
            <td>
                <i className={`mr-3 ${CS.Icone}`} title={CS.TitreLong} />
            </td>
            <td>{Ind.Nom}</td>
            <td>
                {Ind.Adresse.Ad1}
                {Ind.Adresse.Ad2.length>0 && <br/>}{Ind.Adresse.Ad2}
                <br/>{Ind.Adresse.Cp} {Ind.Adresse.Ville} 
                {Ind.Adresse.Pays != "FRANCE" && <br/>}{pays}
            </td>
            <td>
                <LotsList LsLots={LsLots} />
           </td>
        </tr>
    );
};

const PageProprietairesCS = ({ Proprietaires, Ind }) => {
    if (estEnCoursDeChargement(Proprietaires)) return <Chargement />;

    let solde = 0;

    const Entete = (
        <tr>
            <th>CS</th>
            <th>Nom et prénom</th>
            <th>Adresse</th>
            <th>Lots</th>
        </tr>
    );

    const Lignes = Proprietaires.map((pro, index) => {
        const Couleur = pro.Ind.Code === Ind.Code ? 'table-info' : '';
        return <LigneCoproprio key={index} {...pro} Couleur={Couleur} />;
    });

    const Pied = (
        <tr className="table-primary">
            <th colSpan="2">&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
        </tr>
    );

    return (
        <div className="container col-xl-10">
            <div className="alert alert-info">
                {/* <strong>Soldes</strong> tenant compte d&apos;éventuels mouvements futurs programmés */}
            </div>
            <Tableau Entete={Entete} Lignes={Lignes} Pied={Pied} /> 
        </div>
    );
};
PageProprietairesCS.displayName = 'PageProprietairesCS';
PageProprietairesCS.requiredProps = [
    'Proprietaires', // Liste des propriétaires
    'Ind', // Information sur le propriétaire
];

function mapStateToProps({
    CopStore: { Proprietaires },
    ProStore: {
        Pro: { Ind },
    },
}) {
    return { Proprietaires, Ind };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(PageProprietairesCS));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageProprietairesCS.js